/**
 * Native viewBox dimensions for tactic icons.
 * Used to compute correct aspect-ratio-preserving default sizes
 * when placing icons on the map canvas.
 *
 * Format: [width, height] from each icon's SVG viewBox.
 */
export const TACTIC_ICON_DIMENSIONS: Record<string, [number, number]> = {
  AccessibilityRestroom: [73, 83],
  AccessRestroom: [115, 95],
  AED: [77, 75],
  BikeRoom: [121, 73],
  Booth: [104, 53],
  Coffee: [80, 74],
  Data: [70, 70],
  DataRoom: [89, 75],
  Electrical: [125, 75],
  Elevator: [75, 75],
  Exit: [63, 47],
  FemaleRestroom: [38, 80],
  FireExtinguisher: [60, 60],
  FirstAid: [75, 75],
  FoodAndBev: [110, 75],
  GenderNeutral: [69, 82],
  Gym: [89, 75],
  JanitoralCloset: [120, 85],
  Kitchen: [89, 75],
  KitchenPlate: [111, 72],
  Library: [82, 75],
  LibraryRoom: [100, 100],
  Lobby: [82, 74],
  Lockers: [80, 80],
  Mail: [112, 75],
  MaleRestroom: [29, 80],
  Mechanical: [86, 86],
  MechanicalRoom: [134, 76],
  MicrophoneRoom: [130, 80],
  MothersRoom: [166, 101],
  NoSound: [128, 128],
  Phone: [64, 64],
  PhoneRoom: [141, 75],
  Printer: [75, 75],
  QuietRoom: [124, 80],
  ScienceLab: [83, 117],
  ServerRoom: [98, 75],
  Shower: [89, 93],
  SoundBooth: [82, 75],
  Stairs: [75, 75],
  Storage: [80, 80],
  ToiletRestroom: [109, 93],
  TrashRoom: [96, 74],
  WellnessRoom: [98, 75]
};

/**
 * Given a tactic icon name and a max bounding size, return
 * width and height that preserve the icon's native aspect ratio.
 */
export function getIconDimensions(
  iconName: string,
  maxSize = 100
): { width: number; height: number } {
  const dims = TACTIC_ICON_DIMENSIONS[iconName];
  if (!dims) return { width: maxSize, height: maxSize };

  const [nativeW, nativeH] = dims;
  const scale = maxSize / Math.max(nativeW, nativeH);
  return {
    width: Math.round(nativeW * scale),
    height: Math.round(nativeH * scale)
  };
}
